module.exports = __webpack_public_path__ + "8b3e448d3b7fde45730cfd6d69b4fad2.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/2000_l_20.mp3
// module id = 445
// module chunks = 0